import React from 'react'
import { Image } from 'src/components/ui/Image'
import Slider from 'src/components/ui/Slider/Slider'

interface BenefitCard {
  icon: string
  titleText: string
  descriptionText: string
}

interface CartaoPresenteBenefitsProps {
  cards: BenefitCard[]
  titleCard: string
}

const CartaoPresenteBenefits: React.FC<CartaoPresenteBenefitsProps> = ({
  cards,
  titleCard,
}) => {
  return (
    <section className="w-full max-w-[1440px] mx-auto px-4 md:pl-20 pb-8 my-[100px] overflow-hidden">
      <Slider
        title={titleCard}
        itemQuantity={cards.length}
        skeletonStyles="w-[270px] h-[320px]"
        hasScrollbar
      >
        {cards.map((card, index) => (
          <li key={index}>
            <div
              className={`flex flex-col w-[270px] h-[320px] items-center justify-start text-center border border-[#F7F8F9] rounded-[10px] p-5 ${
                index === 0
                  ? 'bg-[#3643BA] text-white border-none'
                  : 'text-[#616161]'
              }`}
            >
              <div
                className={`w-[96px] h-[96px] rounded-[50px] flex justify-center items-center self-start mb-5 ${
                  index === 0 ? 'bg-[#7AFFA6]' : 'bg-[#F7F8F9]'
                }`}
              >
                <Image
                  src={card.icon}
                  alt={card.titleText}
                  className="w-10 h-10 object-contain"
                />
              </div>
              <h3 className="text-lg font-semibold mb-2 self-start">
                {card.titleText}
              </h3>
              <p className="text-base self-start text-left">
                {card.descriptionText}
              </p>
            </div>
          </li>
        ))}
      </Slider>
    </section>
  )
}

export default CartaoPresenteBenefits
